/* =========================================================
   PB:NEW 2026-06-04 — Lazy image loader
   ---------------------------------------------------------
   Images in opted-in sections render with their URLs held in
   data-src / data-srcset (NOT src / srcset), so zero image
   bytes are fetched during initial page load.

   When the section scrolls into view — even slightly — this
   script swaps:
     data-src    -> src
     data-srcset -> srcset
   for every <img data-pb-lazy-img> inside it, so the browser
   then loads them.

   Sections opt in by carrying one of the classes listed in
   SECTION_SELECTOR below: .pb-coll-tabs (Collection tabs
   slider), .pb-showcase (PB Collections Showcase), and
   .pb-formulations (Formulations), .pb-grv (PB Grid Reveal),
   .pb-timeline (PB Timeline), .pb-ba (PB Before & After), and
   .pb-vault (PB Vault Scroll).

   Runs once per image (the data-src removal is the guard).

   Exposes window.PBLazyImage.refresh(root) so sections that
   render client-side (e.g. Shopify section reload) can re-hook
   after the DOM mutates.
   ========================================================= */
(function () {
  if (window.PBLazyImage) return; // singleton

  // Sections that opt into lazy images. Add a class here to enable a section.
  var SECTION_SELECTOR = '.pb-coll-tabs, .pb-showcase, .pb-formulations, .pb-grv, .pb-timeline, .pb-ba, .pb-vault, .pb-blog, .pb-social';

  function loadImage(img) {
    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }
    img.removeAttribute('data-pb-lazy-img');
  }

  function loadSection(section) {
    var imgs = section.querySelectorAll('img[data-pb-lazy-img]');
    Array.prototype.forEach.call(imgs, loadImage);
  }

  function makeObserver() {
    if (!('IntersectionObserver' in window)) {
      // No IO support — load everything immediately.
      return { observe: function (el) { loadSection(el); } };
    }
    return new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadSection(entry.target);
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px', threshold: 0 });
  }

  var observer = makeObserver();

  function observe(section) {
    if (section.dataset.pbLazyImgObserved === '1') return;
    section.dataset.pbLazyImgObserved = '1';
    observer.observe(section);
  }

  function refresh(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(document); });
  } else {
    refresh(document);
  }

  // Shopify theme editor: re-hook a freshly reloaded section.
  document.addEventListener('shopify:section:load', function (e) { refresh(e.target); });

  window.PBLazyImage = { refresh: refresh };
})();
